import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Compass } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="bw-header" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <Compass className="w-6 h-6" style={{ color: "var(--bw-brand)" }} strokeWidth={1.5} />
          <span className="font-display font-black text-xl tracking-tight" style={{ color: "var(--bw-text-primary)" }}>
            BuildWise <span style={{ color: "var(--bw-accent)" }}>AI</span>
          </span>
        </Link>
        <nav className="flex items-center gap-4">
          <Link to="/reviews" className="text-sm font-semibold hover:underline hidden sm:inline" data-testid="nav-reviews">
            Reviews
          </Link>
          <Link to="/documents" className="text-sm font-semibold hover:underline hidden sm:inline" data-testid="nav-documents">
            Documents
          </Link>
          {user && user.id ? (
            <>
              <Link to="/dashboard" className="text-sm font-semibold hover:underline" data-testid="nav-dashboard">
                Dashboard
              </Link>
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="btn-outline text-sm"
                data-testid="nav-logout"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-semibold hover:underline" data-testid="nav-login">
                Log in
              </Link>
              <Link to="/signup" className="btn-primary text-sm" data-testid="nav-signup">
                Get Started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
